import React from 'react';
const MobileContext = React.createContext({});
export const MobileProvider = MobileContext.Provider;
export default MobileContext;